import { CreateProductSKU } from '@src/components/createProduct/CreateProductSKU';
import { CreateService } from '@src/components/createProduct/CreateService';
import { CreateSponsor } from '@src/components/createProduct/CreateSponsor';
import { Page } from '@src/components/layout/Page';
import { createFileRoute } from '@tanstack/react-router';
import { HStack, Tabs, TabsContent, TabsList, TabsTrigger, VStack } from 'ui_2';
import z from 'zod';

type Tab = 'sponsor' | 'service' | 'productSKU';

export const tabs_search = z.object({
  tab: z
    .enum(['sponsor', 'service', 'productSKU'])
    .optional()
    .default('sponsor'),
});

export const Route = createFileRoute('/operatoor/create')({
  component: RouteComponent,
  validateSearch: tabs_search,
});

function RouteComponent() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <Page>
      <Tabs
        value={tab}
        onValueChange={(value) =>
          navigate({
            to: Route.to,
            search: {
              tab: value as Tab,
            },
          })
        }
        className='flex w-full flex-col items-center'
      >
        <HStack className='w-full justify-center'>
          <TabsList>
            <TabsTrigger value='sponsor'>Sponsor</TabsTrigger>
            <TabsTrigger value='service'>Service</TabsTrigger>
            <TabsTrigger value='productSKU'>Product SKU</TabsTrigger>
          </TabsList>
        </HStack>

        <div className='w-full max-w-3xl justify-center pt-8'>
          <TabsContent value='sponsor'>
            <CreateSponsor />
          </TabsContent>
          <TabsContent value='service'>
            <CreateService />
          </TabsContent>
          <TabsContent value='productSKU'>
            <CreateProductSKU />
          </TabsContent>
        </div>
      </Tabs>
    </Page>
  );
}
